import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function GoogleAnalytics() {
  const location = useLocation();

  useEffect(() => {
    window.gtag?.("set", "page_path", location.pathname + location.search);
    window.gtag?.("event", "page_view");
  }, [location]);

  return null;
}
